<template>
  <Hero :title-length="show.title.length" :longest-word="longestWord">
    <template v-if="cover" #background>
      <NuxtImg :src="cover.filename" width="1600" quality="60" format="webp" :alt="cover.alt || ''" />
    </template>
    <h1>{{ show.title }}</h1>
    <p>{{ show.year ? `Seizoen ${show.year}, ` : '' }}{{ blok.items?.length ?? 0 }} foto’s</p>
  </Hero>
  <Container>
    <LazySbText :blok="blok" />
    <LazyGallery :items="blok.items ?? []" :title="show.title" />
  </Container>
</template>
<script setup>
const { formatAlbum, formatBreadcrumbs } = useHrMeta()
const props = defineProps({ blok: Object })

// Albums are named like "2025 - Effe Wachten": the season on its own line, the show as the title
const show = computed(() => {
  const title = String(props.blok.title ?? '').replace(/\.\.\./g, '…')
  const match = /^(\d{4})\s*-\s*(.+)$/.exec(title)
  return match ? { year: match[1], title: match[2] } : { year: '', title }
})
const longestWord = computed(() => Math.max(0, ...show.value.title.split(/\s+/).map(word => word.length)))
const cover = computed(() => props.blok.items?.[0])

formatAlbum({ title: props.blok.title, description: props.blok.description, items: props.blok.items })
formatBreadcrumbs()
</script>
